module.exports = __webpack_public_path__ + "static/media/astron-boy.regular.f4d3a83e.ttf";